export default __webpack_public_path__ + "static/media/designProTextIcon.1bd57c45.svg";